var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "fileinput fileinput-new",
      attrs: { "data-provides": "fileinput" }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.config.type != "video" &&
                _vm.config.type != "audio" &&
                _vm.config.type != "article" &&
                _vm.config.type != "model3d" &&
                _vm.config.type != "unity3d",
              expression:
                "\n      config.type != 'video' &&\n        config.type != 'audio' &&\n        config.type != 'article' &&\n        config.type != 'model3d' &&\n        config.type != 'unity3d'\n    "
            }
          ],
          staticClass: "fileinput-new thumbnail",
          staticStyle: {
            width: "200px",
            height: "150px",
            "margin-bottom": "20px"
          },
          style: {
            width: _vm.config.type === "audio" ? "auto" : 200
          },
          attrs: { "data-role": "initImgPreview" }
        },
        [
          !_vm.config.nolocal
            ? _c(
                "label",
                {
                  staticStyle: { cursor: "pointer" },
                  attrs: { for: "file-" + _vm.id }
                },
                [
                  _c("img", {
                    attrs: { src: require("../assets/pages/img/noimage.png") }
                  })
                ]
              )
            : _c(
                "label",
                {
                  staticStyle: { cursor: "pointer" },
                  on: {
                    click: function($event) {
                      return _vm.openSpace()
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: require("../assets/pages/img/noimage.png") }
                  })
                ]
              )
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "fileinput-preview fileinput-exists thumbnail",
        staticStyle: {
          "/*max-height": "110px",
          "*/max-width": "50%",
          "margin-left": "0",
          "margin-bottom": "20px"
        }
      }),
      _vm._v(" "),
      _c("div", [
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.config.nolocal,
                expression: "!config.nolocal"
              }
            ],
            staticClass: "btn btn-file btn m-white m-btn-auto"
          },
          [
            _c("span", { staticClass: "fileinput-new" }, [
              _vm._v(" 本地上传 ")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "fileinput-exists " }, [
              _vm._v(" 重新选择 ")
            ]),
            _vm._v(" "),
            _c("input", {
              attrs: {
                "data-role": "file",
                type: "file",
                id: "file-" + _vm.id,
                name: _vm.config.name,
                accept: _vm.config.accept || _vm.defaultAccepts[_vm.config.type]
              },
              on: {
                change: function($event) {
                  return _vm.fileChg($event)
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.config && _vm.config.space == "image"
          ? _c(
              "a",
              {
                staticClass: "btn m-white m-btn-auto",
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.openSpace()
                  }
                }
              },
              [_vm._v("\n      从我的图片中选择\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.config && _vm.config.space == "video"
          ? _c(
              "a",
              {
                staticClass: "btn m-white m-btn-auto",
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.openVideoSpace()
                  }
                }
              },
              [_vm._v("\n      从我的视频中选择\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.config && _vm.config.space == "audio"
          ? _c(
              "a",
              {
                staticClass: "btn m-white m-btn-auto",
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.openAudioSpace()
                  }
                }
              },
              [_vm._v("\n      从我的音频中选择\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.config && _vm.config.space == "model3d"
          ? _c(
              "a",
              {
                staticClass: "btn m-white m-btn-auto",
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.openModel3dSpace()
                  }
                }
              },
              [_vm._v("\n      从我的3D模型中选择\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.config && _vm.config.space == "unity3d"
          ? _c(
              "a",
              {
                staticClass: "btn m-white m-btn-auto",
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.openUnity3dSpace()
                  }
                }
              },
              [_vm._v("\n      从我的3D场景中选择\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.config && _vm.config.space == "miniapp"
          ? _c(
              "a",
              {
                staticClass: "btn m-white m-btn-auto",
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.openMiniappSpace()
                  }
                }
              },
              [_vm._v("\n      从我的3D场景中选择\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.config && _vm.config.space == "article"
          ? _c(
              "a",
              {
                staticClass: "btn m-white m-btn-auto",
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.openArticleSpace()
                  }
                }
              },
              [_vm._v("\n      从我的文章中选择\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn m-white m-btn-auto fileinput-exists",
            attrs: { href: "javascript:void(0);", "data-dismiss": "fileinput" },
            on: {
              click: function($event) {
                return _vm.clear()
              }
            }
          },
          [_vm._v("\n      删除\n    ")]
        )
      ]),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "noimg-pic", staticStyle: { display: "none" } },
      [
        _c("img", {
          attrs: { src: require("../assets/pages/img/noimage.png") }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }